import { Role } from '@things-factory/auth-base'
import { getRepository } from '@things-factory/shell'

import { TutorialRole } from '../../../entities'

export const tutorialRoleAssignmentsResolver = {
  async tutorialRoleAssignments(_: any, { tutorialId }, context: ResolverContext) {
    const tutorialRole = await getRepository(TutorialRole).find({
      where: {
        tutorial: tutorialId
      },
      relations: ['role', 'tutorial', 'domain']
    })

    let items: any[], total: number
    ;[items, total] = await getRepository(Role).findAndCount({
      relations: ['domain', 'creator', 'updater']
    })

    items.map(item => {
      item.assigned = !!tutorialRole.some(tutorialRole => tutorialRole.role.id === item.id)
    })

    return { items, total }
  }
}
